'use strict';

const alertMessage = require('../utils/alertMessage');
const csrf = require('cisalfa/csrf/csrf');

function setWishlistIconInList(trigger) {
    // The function is triggered on load, param is used to avoid this
    if (!trigger) return;

    const originalWishlistList = sessionStorage.getItem('originalWishlistList');
    const wishlistList = sessionStorage.getItem('wishlistList');
    if (!originalWishlistList && !wishlistList) return;

    const originalList = originalWishlistList ? originalWishlistList.split(",") : [];
    const masterList = wishlistList ? wishlistList.split(",") : [];
    // :not(.js-wishlist-checked) keeps this cheap when called again after "show
    // more" appends tiles — already-checked tiles are skipped instead of the
    // whole accumulated grid being re-walked on every load.
    const tiles = document.querySelectorAll("div.product.cc-product:not(.js-wishlist-checked)");

    if (!tiles?.length) return;

    tiles.forEach(item => {
        item.classList.add("js-wishlist-checked");

        let pid = item.getAttribute("data-pid");
        let matched = false;

        // Color-level matching: check if any wishlist variant belongs to this tile's VG/product
        if (pid && originalList.length) {
            matched = originalList.some(function (wlPid) {
                return wlPid === pid || wlPid.indexOf(pid + '|') === 0;
            });
        }

        // Fallback to master-level matching only for non-VG tiles (pid equals pidmaster)
        if (!matched && masterList.length) {
            let pidMaster = item.getAttribute("data-pidmaster");
            if (!pidMaster || pidMaster === pid) {
                if ((pidMaster || pid) && masterList.includes(pidMaster || pid)) {
                    matched = true;
                }
            }
        }

        if (matched) {
            const button = item.querySelector("button.cc-tile__wishlist.cc-icon-wishlist");
            if (button) {
                button.classList.add("js-added-wishlist");
                button.classList.add("cc-icon-wishlist--added");
                button.setAttribute("aria-pressed", "true");
            }
        }
    });
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', async function (e) {
            e.preventDefault();
            var url = $(this).attr('href') || $(this).data('href');
            var pid = $(this).closest('.product').data('pid') || $(this).closest('.product-detail').data('pid');
            var pidVariant = $(this).closest('.product').data('pidvariant') || $(this).closest('.product-detail').data('pidvariant');
            var optionId = $('.js-pdp-main').find('.product-option').data('option-id');
            var optionVal = $('.js-pdp-main').find('.options-select.selected').data('value-id');
            var countWrap = $('.js-wishlist');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            var $el = $(this);

            if ($(this).hasClass('js-added-wishlist')) {
                url = $(this).data('remove');
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        if (data.success) {
                            $el.removeClass('js-added-wishlist');
                            $el.removeClass('cc-icon-wishlist--added');
                            $el.removeAttr('aria-pressed');
                        }

                        if (typeof data.wishlistLength !== "undefined") {
                            if (data.wishlistLength === 0) {
                                $(countWrap).addClass('d-none');
                                $(countWrap).removeClass('d-inline-flex');
                            } else {
                                $(countWrap).addClass('d-inline-flex');
                                $(countWrap).removeClass('d-none');
                            }
                            $(countWrap).text(data.wishlistLength);
                        }

                        if (data.redirectUrl) {
                            location.href = data.redirectUrl;
                        } else {
                            alertMessage(data.msg, 'cc-alert--success');
                        }
                        //IOC-281
                        if (data.analyticsData) {
                            dataLayer.push(data.analyticsData);
                        }

                        if ($el.closest('.js-product-slider.js-wishlist-slider').length > 0) {
                            const $slickSlider = $el.closest('.js-product-slider').find('.js-slider');
                            const slideIndex = $el.closest('.slick-slide').index();
                            $slickSlider.slick('slickRemove', slideIndex);
                        }

                        sessionStorage.setItem('wishlistList', data.wishlistList);
                        sessionStorage.setItem('originalWishlistList', data.originalWishlistList);
                    },
                    error: function (err) {
                        alertMessage(err.msg, 'cc-alert--danger');
                    }
                });
            } else {
                var csrf_token = await csrf.methods.getCsrfToken();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        pid: pidVariant || pid,
                        optionId: optionId,
                        optionVal: optionVal,
                        csrf_token: csrf_token.token
                    },
                    success: function (data) {
                        if (data.success) {
                            $el.addClass('js-added-wishlist');
                            $el.addClass('cc-icon-wishlist--added');
                            $el.attr('aria-pressed', 'true');
                        }

                        if (data.wishlistLength) {
                            if (data.wishlistLength === 0) {
                                $(countWrap).addClass('d-none');
                                $(countWrap).removeClass('d-inline-flex');
                            } else {
                                $(countWrap).addClass('d-inline-flex');
                                $(countWrap).removeClass('d-none');
                            }
                            $(countWrap).text(data.wishlistLength);
                        }
                        if (data.redirectUrl) {
                            location.href = data.redirectUrl;
                        } else {
                            alertMessage(data.msg, 'cc-alert--success', false, true);
                        }
                        //IOC-281
                        if (data.analyticsData) {
                            dataLayer.push(data.analyticsData);
                        }

                        sessionStorage.setItem('wishlistList', data.wishlistList);
                        sessionStorage.setItem('originalWishlistList', data.originalWishlistList);
                    },
                    error: function (err) {
                        alertMessage(err.msg, 'cc-alert--danger');
                    }
                });
            }
        });
    },
    setWishlistIconInList: setWishlistIconInList
};
